export class ProcessContentAssistantActionSettings {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
